import { render, staticRenderFns } from "./compare4.vue?vue&type=template&id=7ddb4725&scoped=true"
import script from "./compare4.vue?vue&type=script&lang=js"
export * from "./compare4.vue?vue&type=script&lang=js"
import style0 from "./compare4.vue?vue&type=style&index=0&id=7ddb4725&prod&lang=css"
import style1 from "./compare4.vue?vue&type=style&index=1&id=7ddb4725&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb4725",
  null
  
)

export default component.exports